// src/components/ActivityPanels.tsx
import * as React from 'react'
import { Box, Stack, Text, HStack, Separator } from '@chakra-ui/react'

export type ActivityPanelItem = {
  type: string // e.g. "TOJ", "Beratung", "Schulung"
  used: number
  planned: number
  tip: string
}

export function ActivityPanels({
  items,
  title = 'Alle Leistungen',
  variant = 'list',
  height,
  showTotal = true,
  noRecipientSelected = false,
}: {
  items: ActivityPanelItem[]
  title?: string
  variant?: 'list' | 'cards'
  height?: number
  showTotal?: boolean
  noRecipientSelected?: boolean
}) {
  const fmt = React.useMemo(() => new Intl.NumberFormat('de-DE'), [])
  const show = (v: number) => (noRecipientSelected ? '-' : fmt.format(v))

  const totalUsed = items.reduce((s, it) => s + (it.used || 0), 0)
  const totalPlanned = items.reduce((s, it) => s + (it.planned || 0), 0)

  const Row = ({ heading, used, planned }: { heading: string; used: number; planned: number }) => (
    <Stack gap={1}>
      <HStack gap={2}>
        <Text textStyle="smNormal">{heading}</Text>
      </HStack>
      <HStack gap={0} align="start">
        <Stack gap={0} minW="0" flex="1">
          <Text textStyle="fontsBody">{show(used)}</Text>
          <Text textStyle="xsNormal">Geleistet</Text>
        </Stack>
        <Stack gap={0} minW="0" flex="1">
          <Text textStyle="fontsBody">{show(planned)}</Text>
          <Text textStyle="xsNormal">Bestellt</Text>
        </Stack>
      </HStack>
    </Stack>
  )

  if (variant === 'list') {
    return (
      <Box
        bg="bg"
        p={2}
        h={height ? `${height}px` : '100%'}
        overflow="visible"
        // display="flex"
      >
        <Stack gap={3} separator={<Separator borderColor="border" flex="1" minH={0} />}>
          <Row heading={title} used={totalUsed} planned={totalPlanned} />
          {items.map(it => (
            <Row key={it.type} heading={it.type} used={it.used} planned={it.planned} />
          ))}
        </Stack>
      </Box>
    )
  }
  return (
    <Stack>
      <Box>{/* ... */}</Box>
    </Stack>
  )
}
